import {
  SET_LEVEL_ACTION,
  SET_TIPO_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_INICIAL_ACTION,
} from './actions.type';
import {
  SET_TIPO,
  SET_LEVEL,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
} from './mutations.type';

export default {
  [SET_TIPO_ACTION](context, tipo) {
    context.commit(SET_TIPO, tipo);
  },
  [SET_LEVEL_ACTION](context, level) {
    context.commit(SET_LEVEL, level);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
};
